/* eslint-disable no-unused-vars */
import type { ISlideModel, ISlideExtensions } from './slide-model.interface';
import { ILayoutDataModel, STSlideLayoutType } from '@tencent/slide-sdk-model';

export interface ILayoutModel extends ISlideModel {
    sdkData: ILayoutDataModel | null;
    masterId?: string;
    layoutType?: STSlideLayoutType;
    extensions: ILayoutExtensions;
    addNewPlaceholder(props, actionId: string);
}

export type LayoutModelSdkTypeV3 = ILayoutDataModel | null;

export const INSERT_PLACEHOLDER_TYPE = {
    INSERT_PLACEHOLDER_HORZ_CONTENT: 'insert-placeholder-horz-content',
    INSERT_PLACEHOLDER_VERT_CONTENT: 'insert-placeholder-vert-content',
    INSERT_PLACEHOLDER_HORZ_TEXT: 'insert-placeholder-horz-text',
    INSERT_PLACEHOLDER_VERT_TEXT: 'insert-placeholder-vert-text',
    INSERT_PLACEHOLDER_PICTURE: 'insert-placeholder-picture',
    INSERT_PLACEHOLDER_TABLE: 'insert-placeholder-table',
};

/**
 * 版式上的扩展字段，目前没有所以是空
 */
export interface ILayoutExtensions extends ISlideExtensions {}
